import { render, staticRenderFns } from "./drag-btn.vue?vue&type=template&id=012a7d0e&scoped=true&"
import script from "./drag-btn.vue?vue&type=script&lang=ts&"
export * from "./drag-btn.vue?vue&type=script&lang=ts&"
import style0 from "./drag-btn.vue?vue&type=style&index=0&id=012a7d0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012a7d0e",
  null
  
)

export default component.exports